<template>
  <div class="member-menu">
      <ul class="items">
        <li><router-link to="/plan/feed"><img :src="HomeIcon" /><span>{{t("Feed")}}</span></router-link></li>
        <li><router-link to="/plan/lifesavers"><img :src="LifesaverIcon" /><span>{{t("Lifesavers")}}</span></router-link></li>
        <li><router-link to="/plan/tools"><img :src="ToolsIcon" /><span>{{t("Tools")}}</span></router-link></li>
        <li><router-link to="/plan/bonus"><img :src="BonusIcon" /><span>{{t("Bonus")}}</span></router-link></li>
      </ul>
  </div>
</template>

<script>
import t from '@/lib/Locale';

import HomeIcon from '@/assets/icons/navbar/home.png';
import ToolsIcon from '@/assets/icons/navbar/tools.png';
import ProductsIcon from '@/assets/icons/navbar/recommendations.png';
import BonusIcon from '@/assets/icons/navbar/bonuses.png';
import LifesaverIcon from '@/assets/icons/navbar/lifesaver.png';

export default {
  name: "MemberMenu",
  data() {
    return {
      HomeIcon, ToolsIcon, ProductsIcon, BonusIcon, LifesaverIcon
    }
  },
  methods :{
    t,
  }
}
</script>
